query BusinessUnitsTableData(
  $days: Int!
  $environmentFilter: ConditionString
  $calculationDateFrom: ConditionDateTime
  $calculationDateTo: ConditionDateTime
) {
  score_web_products(
    calculation_date_ge: $calculationDateFrom
    calculation_date_le: $calculationDateTo
    timeframe_days_eq: { value: [$days] }
    environment_eq: $environmentFilter
  ) {
    unit_id
    environment
    timeframe_days
    unique_issues
    total_issues_critical
    total_issues_serious
    score
    calculation_date
  }
}
